import { initHeader } from './components/header';
import { initMenu, initSubmenus } from './components/menu';
import { captureMarks, fillMarks } from './utils/tracking';

// One entry point, one place to see what runs. Each init bails out on its own
// if its markup is absent, so templates decide what exists.
const boot = () => {
  initHeader();
  initMenu();
  initSubmenus();
  // Campaign tags are caught on every page, not only where a form is: the tag
  // is in the address of the page someone lands on, not of the one they write
  // from. Filling costs nothing where no form carries the fields.
  captureMarks();
  fillMarks();
};

if ('loading' === document.readyState) {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
